import React from 'react';
import { Box, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { align_center,  align_row, vmPageTitleSx } from '../../Styles/VMStyles';
import MUITypography from '../../Components/MUITypography';

function TitleWithBack({ title, onBackClick }) {
  return (
    <Box sx={{ ...align_row }}>
      {onBackClick ? (
      <IconButton
        onClick={onBackClick}
        edge="start"
        sx={{
          padding: '6px',
          minWidth: 'auto',
          width: 'auto',
        }}
      >
        <ArrowBackIcon />
      </IconButton>
      ) : null}
      <Box sx={align_center}>
        <MUITypography variant="pageTitle" ml={2} sx={{ ...vmPageTitleSx, minWidth: '200px' }}>
          {title}
        </MUITypography>
      </Box>
    </Box>
  );
}

export default TitleWithBack;
